import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { BellRing } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useFirma } from "../context/FirmaContext";
import { PopupAvviso, testo } from "./PopupAvviso";

const RIMANDA_DEF = 15;

export default function SollecitoPopup() {
  const { selectedStructure } = useAuth();
  const { identity } = useFirma();
  const nav = useNavigate();
  const opId = identity?.operatore_id;
  const lsKey = `soll-rimanda-${opId}`;
  const [, setTick] = useState(0);
  useEffect(() => { const i = setInterval(() => setTick((n) => n + 1), 60000); return () => clearInterval(i); }, []);
  const rimanda = Number(localStorage.getItem(lsKey) || 0);
  const { data } = useQuery({
    enabled: !!opId, queryKey: ["solleciti-miei", opId, selectedStructure], refetchInterval: 60000,
    queryFn: async () => { try { return (await api.get("/solleciti/miei", { params: { operatore_id: opId, structure_id: selectedStructure } })).data; } catch { return { mancano: [] }; } },
  });
  const mancano = data?.mancano || [];
  const aperto = !!opId && mancano.length > 0 && Date.now() > rimanda;
  const logKey = aperto ? `${opId}|${data?.data}|${data?.turno}|${rimanda}` : null;
  useEffect(() => {
    if (!logKey || localStorage.getItem(`soll-log-${opId}`) === logKey) return;
    localStorage.setItem(`soll-log-${opId}`, logKey);
    api.post("/solleciti/mostrato", { operatore_id: opId, operatore_nome: identity?.operatore_nome, data: data.data, turno: data.turno, structure_id: data.structure_id, stamp: String(rimanda), voci: mancano.map((m) => m.key) }).catch(() => {});
  }, [logKey, opId, identity?.operatore_nome, data, mancano]);
  const chiudi = () => { const t = Date.now() + (data?.ripeti_min || RIMANDA_DEF) * 60000; localStorage.setItem(lsKey, String(t)); setTick((n) => n + 1); };
  return (
    <PopupAvviso open={aperto} onClose={chiudi} tono="amber" Icon={BellRing} testid="sollecito-popup"
      titolo={testo(data, "soll_titolo")} descr={testo(data, "soll_testo", { nome: identity?.operatore_nome, minuti: data?.dopo_min || 30 })}
      voci={mancano} onVai={(m) => { chiudi(); nav(m.path); }} />
  );
}
